let galleryLoading = false;

document.addEventListener('click', function (e) {
    const thumb = e.target.closest('.cl-po--gallery-thumbnail');

    if (!thumb) return;

    if (galleryLoading) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
    }

    galleryLoading = true;

    const gallery = document.querySelector('#splide01');
    const featuredContainer =
        document.querySelector('#splide02') ||
        document.querySelector('.product-gallery');

    if (gallery) {
        gallery.style.pointerEvents = 'none';
        gallery.style.opacity = '0.6';
        gallery.style.cursor = 'wait';
        gallery.style.transition = 'opacity .2s ease';
    }

    if (featuredContainer && !document.querySelector('#image-loading-overlay')) {

        const overlay = document.createElement('div');
        overlay.id = 'image-loading-overlay';

        overlay.innerHTML = `
            <div style="
                position:absolute;
                bottom:20px;
                left:50%;
                transform:translateX(-50%);
                background:rgba(0,0,0,.75);
                color:#fff;
                padding:8px 14px;
                border-radius:20px;
                font-size:13px;
                font-family:inherit;
            ">
                Loading image...
            </div>
        `;

        featuredContainer.style.position = 'relative';
        featuredContainer.appendChild(overlay);
    }

    const activeImage =
        document.querySelector('#splide02 .is-active img') ||
        document.querySelector('#splide02 img');

    if (activeImage) {
        activeImage.style.opacity = '0.75';
        activeImage.style.transition = 'opacity .2s ease';
    }

    setTimeout(() => {

        if (gallery) {
            gallery.style.pointerEvents = '';
            gallery.style.opacity = '';
            gallery.style.cursor = '';
        }

        if (activeImage) {
            activeImage.style.opacity = '';
        }

        document
            .querySelector('#image-loading-overlay')
            ?.remove();

        galleryLoading = false;

    }, 2000);

}, true);